











































































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import Report from '@/views/report/index.vue';
import { vueSyncEvent } from '@/utils/index';

const propYear = 'year';

@Component({
  name: 'ReportStepYear',
})
export default class extends Vue {
  private readonly nextYearEnd = `${new Date().getFullYear() + 1}-12-31`;
  private readonly currentYear = new Date().getFullYear();
  @Prop({ default: false }) vertical!: boolean;
  @PropSync(propYear) private syncYear!: number;
  private yearRules: ((v: string) => boolean | string)[] = [];
  private yearMenu = false;

  get minYear() {
    return this.currentYear - 10;
  }

  get maxYear() {
    return this.currentYear + 10;
  }

  get canNextStep() {
    return this.syncYear;
  }

  get reportNextStepEvent() {
    return Report.reportNextStepEvent;
  }

  created() {
    this.yearRules = [
      (v: string) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Financial year'),
        }) as string),
    ];
  }

  private handleYearSelected() {
    this.yearMenu = false;
    this.$nextTick(() => {
      this.syncYear && this.$emit(vueSyncEvent(propYear), this.syncYear);
    });
  }
}
